module.exports = __webpack_public_path__ + "img/829.563f76cd.jpg";